import { useEffect, useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { assignAssessorForm } from "../../../shared/formObjects/application/assignAssessorForm";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function AssignAssessorComponent({ disabled, data }: any) {
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const formApi = useApiClient("AssignAssessor");
  const [formContext, setFormContext] = useState<any>({ options: [] });
  const { id } = useApplicationContext();

  useEffect(() => {
    fetchData("GetActiveUsersByRoles/2,3").then((res) => {
      const options = (res.data as any[])
        .map((user) => ({
          label: user.displayName,
          value: user.userEmail,
        }))
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      setFormContext({ options });
    });
  }, []);

  return (
    <BaseApplicationComponent
      formBody={assignAssessorForm}
      headerLabel="Assign an Assessor"
      editPath="assignassessor"
      apiClient={formApi}
      disabled={disabled}
      data={data}
      formContext={formContext}
      id={id}
    />
  );
}
